function SkeletonLoading({max_width}) {
  return (
    <div className={`animate-pulse w-full ${max_width ? max_width :'max-w-28'}`}>
        <div className={`h-5 min-w-28 w-full bg-gray-200 mt-3 mb-6 rounded`}></div>
    </div>
  )
}

export default SkeletonLoading